<template>
  <div :class="(options.user.loggedIn ? 'test' : 'auth_bg') + ' page-container relative'" v-if="test">
    <md-app md-waterfall md-mode="fixed" id="app">
      <!--Dynamic Navi: overwrite options in view-->
      <md-app-toolbar class="no_padding" v-if="options.user.loggedIn" style="display: none;">
        <NaviTopComponent v-if="options.user.loggedIn && langLoad" :options="options"></NaviTopComponent>
      </md-app-toolbar>
      <md-app-drawer id="side_nav" v-if="options.user.loggedIn && !options.noNav" md-permanent="full">
        <NaviLeftComponent v-if="options.user.loggedIn && langLoad" :options="options"></NaviLeftComponent>
      </md-app-drawer>
      <md-app-content class="no_padding" v-if="langLoad">
        <div id="content" class="content">
          <section v-if="options.isUploading" class="loading_spinner">
            <div class="ladebalken">
              <div class="custom-spinner"></div>
            </div>
          </section>
          <router-view :options.sync="options"></router-view>
          <Success class="successDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"/>
          <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"/>
        </div>
      </md-app-content>
    </md-app>
    <div v-if="options.showAlertBox" id="alertBox" class="md-elevation-11">
      <div style="padding: 40px;">
        <label v-if="options?.alertMessage?.datum && options?.alertMessage?.datum != null && options?.alertMessage?.datum != ''"><span>{{options.Lang.NachrichtVom}} :</span> {{ options.alertMessage.datum }}</label>
        <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
          <p v-html="options.alertMessage.nachricht" style="flex: 1 0 auto !important;"></p>
          <md-button @click="updateSeeAlertStatus()" class="md-raised md-primary" style="width: 200px; margin-left: auto; margin-right: auto;">{{options.Lang.schließen}}</md-button>
        </div>
      </div>
    </div>

    <!-- Global Confirm Overlay - OUTSIDE md-app to cover everything including sidebar -->
    <section v-if="options.globalConfirm && options.globalConfirm.visible" id="globalConfirmOverlay" @click.self="options.globalConfirm.onCancel && options.globalConfirm.onCancel()">
      <div id="globalConfirmModal" class="md-elevation-10" :class="{ 'confirm-styled': options.globalConfirm.styled }">
        <template v-if="options.globalConfirm.styled">
          <!-- Header (same as FormImportTrip) -->
          <div class="confirm-header-row">
            <span class="confirm-dialog-title">{{ options.globalConfirm.title }}</span>
            <NezasaIdBox v-if="options.globalConfirm.nezasaId" :tripid="options.globalConfirm.nezasaId" />
          </div>

          <!-- Content area with message + dropdowns -->
          <div class="confirm-content-area">
            <p class="confirm-message-text">{{ options.globalConfirm.message }}</p>

            <div v-if="options.globalConfirm.brands || options.globalConfirm.mitarbeiter" class="confirm-form-grid">
              <!-- Branding dropdown -->
              <div v-if="options.globalConfirm.brands" class="confirm-grid-col">
                <md-field class="md-focused">
                  <label class="font-600">Branding</label>
                  <md-select v-model="options.globalConfirm.selectedBranding">
                    <md-option
                        v-for="brand in options.globalConfirm.brands"
                        :key="brand.brandingID"
                        :value="String(brand.brandingID)"
                    >{{ brand.name }}</md-option>
                  </md-select>
                </md-field>
              </div>

              <!-- Mitarbeiter dropdown -->
              <div v-if="options.globalConfirm.mitarbeiter" class="confirm-grid-col">
                <md-field class="md-focused">
                  <label class="font-600">{{ options.Lang.Mitarbeiter || 'Employee' }}</label>
                  <md-select v-model="options.globalConfirm.selectedMitarbeiter" :disabled="options.user.trips_isolated === 1">
                    <md-option
                        v-for="(arbeiter, index) in options.globalConfirm.mitarbeiter"
                        :key="index"
                        :value="arbeiter.id"
                    >{{ arbeiter.firstname }} {{ arbeiter.lastname }}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </div>

          <!-- Actions (same layout as FormImportTrip) -->
          <div class="confirm-actions-row">
            <md-button class="md-raised secondary" @click="options.globalConfirm.onCancel && options.globalConfirm.onCancel()">
              <strong>{{ options.Lang.close_window || 'Cancel' }}</strong>
            </md-button>
            <md-button class="md-raised md-primary" @click="options.globalConfirm.onConfirm && options.globalConfirm.onConfirm()">
              <strong>{{ options.globalConfirm.confirmBtnText }}</strong>
            </md-button>
          </div>
        </template>

        <template v-else>
          <p class="confirmTitle">{{ options.globalConfirm.title }}</p>
          <p class="confirmMessage">{{ options.globalConfirm.message }}</p>
          <div v-if="options.globalConfirm.showInput" class="global-confirm-input-wrap" style="padding:0 20px 10px 20px;">
            <md-field class="md-focused">
              <label v-if="options.globalConfirm.inputLabel">{{ options.globalConfirm.inputLabel }}</label>
              <md-input
                v-model="options.globalConfirm.inputValue"
                :placeholder="options.globalConfirm.inputPlaceholder || ''"
                @keyup.enter="options.globalConfirm.onConfirm && options.globalConfirm.onConfirm()"
                ref="globalConfirmInput"
              />
            </md-field>
          </div>
          <div class="confirmButtons" style="display:flex;justify-content:center;gap:1rem;padding:20px;">
            <md-button v-if="!options.globalConfirm.hideCancel" tabindex="7" class="md-raised md-primary" @click="options.globalConfirm.onCancel && options.globalConfirm.onCancel()">{{ options.Lang.schließen || 'Cancel' }}</md-button>
            <md-button tabindex="7" :class="options.globalConfirm.confirmBtnClass" @click="options.globalConfirm.onConfirm && options.globalConfirm.onConfirm()">{{ options.globalConfirm.confirmBtnText }}</md-button>
          </div>
        </template>
      </div>
    </section>

    <!-- Secrets Modal Overlay — OUTSIDE md-app to cover sidebar -->
    <section v-if="options.secretsModal && options.secretsModal.visible" id="secretsModalOverlay" @click.self="options.secretsModal.onClose && options.secretsModal.onClose()">
      <div id="secretsModalBox" class="md-elevation-10">

        <!-- Add Secret mode -->
        <template v-if="options.secretsModal.mode === 'secret'">
          <p class="confirmTitle">Add New Secret</p>
          <p v-if="options.secretsModal.category !== 'nezasa_sets'" style="color:#666;font-size:13px;margin:0 0 20px 0;">Store a new encrypted environment variable in the vault.</p>
          <p v-else style="color:#666;font-size:13px;margin:0 0 20px 0;">Add a Nezasa username/password credential set. URLs are shared.</p>

          <div class="sm-field">
            <label class="sm-label">Category</label>
            <select v-model="options.secretsModal.category" class="sm-input">
              <option value="general">General</option>
              <option value="auth">Auth</option>
              <option value="mail">Mail</option>
              <option value="nezasa">Nezasa</option>
              <option value="nezasa_sets">Nezasa Sets</option>
              <option value="external">External</option>
            </select>
          </div>

          <template v-if="options.secretsModal.category !== 'nezasa_sets'">
            <div class="sm-field">
              <label class="sm-label">Key Name</label>
              <input v-model="options.secretsModal.key_name" class="sm-input" placeholder="e.g. MY_API_KEY" style="text-transform:uppercase;font-family:monospace;" />
            </div>
            <div class="sm-field">
              <label class="sm-label">Value</label>
              <div style="position:relative;">
                <input v-model="options.secretsModal.value" :type="options.secretsModal.showValue ? 'text' : 'password'" class="sm-input" style="padding-right:40px;" />
                <button class="sm-eye-btn" @click="options.secretsModal.showValue = !options.secretsModal.showValue">
                  <md-icon>{{ options.secretsModal.showValue ? 'visibility_off' : 'visibility' }}</md-icon>
                </button>
              </div>
            </div>
            <div class="sm-field">
              <label class="sm-label">Description (optional)</label>
              <input v-model="options.secretsModal.description" class="sm-input" />
            </div>
          </template>

          <template v-else>
            <div class="sm-field">
              <label class="sm-label">Set Name</label>
              <input v-model="options.secretsModal.setName" class="sm-input" placeholder="e.g. explorer, boomerang, live" />
            </div>
            <div class="sm-field">
              <label class="sm-label">Username</label>
              <input v-model="options.secretsModal.setUsername" class="sm-input" />
            </div>
            <div class="sm-field">
              <label class="sm-label">Password</label>
              <div style="position:relative;">
                <input v-model="options.secretsModal.setPassword" :type="options.secretsModal.showPassword ? 'text' : 'password'" class="sm-input" style="padding-right:40px;" />
                <button class="sm-eye-btn" @click="options.secretsModal.showPassword = !options.secretsModal.showPassword">
                  <md-icon>{{ options.secretsModal.showPassword ? 'visibility_off' : 'visibility' }}</md-icon>
                </button>
              </div>
            </div>
          </template>

          <div style="display:flex;justify-content:flex-end;gap:10px;margin-top:24px;padding-top:16px;border-top:1px solid #eee;">
            <md-button class="md-raised secondary" @click="options.secretsModal.onClose && options.secretsModal.onClose()">
              <strong>Cancel</strong>
            </md-button>
            <md-button class="md-raised md-primary" :disabled="options.secretsModal.saving" @click="options.secretsModal.onSave && options.secretsModal.onSave()">
              <strong>{{ options.secretsModal.category === 'nezasa_sets' ? 'Add Nezasa Set' : 'Add Secret' }}</strong>
            </md-button>
          </div>
        </template>

        <!-- Enable Nezasa Set mode -->
        <template v-if="options.secretsModal.mode === 'nezasa_enable'">
          <p class="confirmTitle">Enable Nezasa Set</p>
          <p style="color:#666;font-size:13px;margin:0 0 20px 0;">Select which credential set the application uses. Only one can be active.</p>

          <div v-if="options.secretsModal.nezasaSets.length === 0" style="color:#999;text-align:center;padding:20px;">
            No Nezasa credential sets found. Add one first.
          </div>

          <!-- None option — fallback to .env -->
          <div class="sm-nezasa-row" :class="{ 'sm-nezasa-active': !options.secretsModal.activeNezasaSet || options.secretsModal.activeNezasaSet === 'none' }">
            <div class="sm-nezasa-info">
              <strong>None</strong>
              <span style="color:#888;font-size:12px;margin-left:4px;">(use .env values)</span>
              <span v-if="!options.secretsModal.activeNezasaSet || options.secretsModal.activeNezasaSet === 'none'" class="sm-nezasa-active-badge">ACTIVE</span>
            </div>
            <md-button
              v-if="options.secretsModal.activeNezasaSet && options.secretsModal.activeNezasaSet !== 'none'"
              class="md-raised md-dense"
              @click="options.secretsModal.onSave && options.secretsModal.onSave('none')"
            >Enable</md-button>
            <md-icon v-else style="color:#4caf50;font-size:28px!important;">check_circle</md-icon>
          </div>

          <div v-for="set in options.secretsModal.nezasaSets" :key="set.name" class="sm-nezasa-row" :class="{ 'sm-nezasa-active': set.name === options.secretsModal.activeNezasaSet }">
            <div class="sm-nezasa-info">
              <strong>{{ set.name }}</strong>
              <span v-if="set.name === options.secretsModal.activeNezasaSet" class="sm-nezasa-active-badge">ACTIVE</span>
            </div>
            <md-button
              v-if="set.name !== options.secretsModal.activeNezasaSet"
              class="md-raised md-primary md-dense"
              @click="options.secretsModal.onSave && options.secretsModal.onSave(set.name)"
            >Enable</md-button>
            <md-icon v-else style="color:#4caf50;">check_circle</md-icon>
          </div>

          <div style="display:flex;justify-content:flex-end;margin-top:24px;padding-top:16px;border-top:1px solid #eee;">
            <md-button class="md-raised secondary" @click="options.secretsModal.onClose && options.secretsModal.onClose()">
              <strong>Close</strong>
            </md-button>
          </div>
        </template>

      </div>
    </section>

  </div>
</template>

<script>
import NaviTopComponent from "./components/navi/NaviTopComponent";
import NaviLeftComponent from "./components/navi/NaviLeftComponent";
import Success from "@/components/dialogs/Success"
import Error from "@/components/dialogs/Error"
import NezasaIdBox from "@/components/parts/NezasaIdBox"
import Vue from "vue";
import german from "../../locales/german.json";
import englisch from "../../locales/englisch.json";
import french from "../../locales/french.json";
import dutch from "../../locales/dutch.json";
import greek from "../../locales/greek.json";

const isDev = Vue.config.devtools;
const isStaging = (process.env.NODE_ENV === 'staging')

export default {
  components: {
    NaviTopComponent,
    NaviLeftComponent,
    Success,
    Error,
    NezasaIdBox
  },
  data: function () {
    return {
      test: false,
      langLoad: false,
      options: {
        defaultCount: null,
        showAlertBox: false,
        alertMessage: [],
        showCollectionSettings: true,
        showCollectionForm: false,
        showBrandSettings: false,
        ModulCollections: null,
        ModulSuppliermail:null,
        ModulHelloEdit:null,
        ModulKommentare:null,
        ModulPassolution: null,
        ModulInvoiceCheckout: null,
        modules: [],
        // Declared up-front so child components watching options.GlobalSettings
        // (e.g. the sidebar mode badge) stay reactive when it gets refreshed.
        GlobalSettings: {},
        init: false,
        isUploading: false,
        apiUrl: process.env.VUE_APP_API_URL,
       
        user: {
          supersuper: this.$store.getters.supersuper,
          loggedIn: this.$store.getters.isLoggedIn !== '',
          id: this.$store.getters.getUser.id || false,
          role: this.$store.getters.getUser.role || 0,
          username: this.$store.getters.getUser.username || false,
          firstname: this.$store.getters.getUser.firstname || "",
          lastname: this.$store.getters.getUser.lastname || "",
          company: this.$store.getters.getUser.company || null,
          pic: this.$store.getters.getUser.pic || null,
          token: this.$store.getters.isLoggedIn || false,
          lang: this.$store.getters.getUser.lang || false,
          trips_isolated: this.$store.getters.getUser.trips_isolated,
          brandings: this.$store.getters.getUser.brandings || false
        },
        dbg: (this.$route.query.dbg && parseInt(this.$route.query.dbg) === 1),
        noNav: true,
        currentRoute: false,
        snackbar: {
          show: false,
          class: 'success',
          msg: 'Erfolgreich gespeichert!',
          icon: 'check'
        },
        Lang : null,
        German : german,
        Englisch : englisch,
        French: french,
        Dutch: dutch,
        Greek: greek,
        currentClient: null,
        currentProcess: null,
        currentSupplier: null,
        currentUser: null,
        currentFormUser: null,
        currentTrip: null,
        showClientForm: false,
        showSuppliersForm: false,
        showchangePW: false,
        showImportTripForm: false,
        showUploadPdfForm: false,
        showEditCategorieForm: false,
        showEditHelloForm: false,
        showaddKommentarForm: false,
        showTimelineForm: false,
        showGlobalInfoForm: false,
        showBrandForm: false,
        showCustomerLoginForm: false,
        showPdfCategorieForm: false,
        showFirstImageForm: false,
        showSendEmailToSupplierForm: false,
        showClientDetails: false,
        userFormEditable: true,
        sendEmailToSupplierFormEditable: true,
        currentFormPOI: null,
        POIFormEditable: true,
        showPOIForm: false,
        clientFormEditable: true,
        tripFormEditable: true,
        showUserForm: false,
        showSuccess: false,
        showSuccessHtml: false,
        showError: false,
        showDelete: false,
        successMsg: null,
        successMsgOld: '',
        errorMsg: null, 
        deleteMsg: null,
        isUsers: false,
        isClients: false,
        isTrips: false,
        isTripsArchived: false,
        newClientCreated: 0,
        // Global confirm state
        globalConfirm: {
          visible: false,
          styled: false,
          title: '',
          message: '',
          confirmBtnText: 'Confirm',
          confirmBtnClass: 'md-raised md-primary',
          nezasaId: null,
          brands: [],
          mitarbeiter: [],
          selectedBranding: '',
          selectedMitarbeiter: null,
          showInput: false,
          inputLabel: '',
          inputPlaceholder: '',
          inputValue: '',
          onConfirm: null,
          onCancel: null
        },
        // Secrets modal — driven by SuperAdmin, rendered outside md-app in App.vue
        secretsModal: {
          visible: false,
          mode: 'secret',
          // Add Secret fields
          key_name: '',
          value: '',
          category: 'general',
          description: '',
          showValue: false,
          saving: false,
          // Nezasa Set fields
          setName: '',
          setUsername: '',
          setPassword: '',
          showPassword: false,
          // Nezasa Enable modal
          nezasaSets: [],
          activeNezasaSet: '',
          // Callbacks
          onSave: null,
          onClose: null
        }
      },
    }
  },
  watch: {
    '$route'(to) {
      this.options.currentRoute = this.$router.currentRoute.name;
      document.title = to.meta.title;
      if (to.name === 'signIn') {
        this.options.isUploading = false;
      }
      this.options.isClients = this.options.currentRoute === 'Clients';
      this.options.isUsers = this.options.currentRoute === 'Users';
      this.options.isSuppliers = this.options.currentRoute === 'Suppliers' || this.options.currentRoute === 'SuppliersArchived';
      this.options.isTrips = this.options.currentRoute === 'Trips' || this.options.currentRoute === 'TripsArchived';
      this.options.isTripsArchived = this.options.currentRoute === 'TripsArchived';
      this.options.isSettings = this.options.currentRoute === 'Settings' ||  this.options.currentRoute === 'editPDF';
      this.options.isTitelbilder = this.options.currentRoute === 'imgKat' ||  this.options.currentRoute === 'imgVerwaltung';
    },
    '$route.fullPath'(newVal, oldVal) {
      if (newVal.startsWith('/trips')) {
        this.getModules(); // Your method that refetches and reassigns `options.modules`
      }
    },
    'options.isUploading'(val) {
      if (val && this.$route && this.$route.name === 'signIn') {
        this.options.isUploading = false;
      }
    }
  },
  beforeMount() {
    this.options.isUploading = false;
  },
  async mounted() {
    this.options.isUploading = false;
    this.langLoad = true;
    this.options.Lang = this.options.German;
    await this.getModules();
    this.options.init = true;
    this.options.isClients = this.options.currentRoute === 'Clients';
    this.options.isSuppliers = this.options.currentRoute === 'Suppliers' || this.options.currentRoute === 'SuppliersArchived';
    this.options.isUsers = this.options.currentRoute === 'Users';
    this.options.isTrips = this.options.currentRoute === 'Trips' || this.options.currentRoute === 'TripsArchived';
    this.options.isTripsArchived = this.options.currentRoute === 'TripsArchived';
    this.options.isSettings = this.options.currentRoute === 'Settings' ||  this.options.currentRoute === 'editPDF';
    this.options.successMsg = this.options.Lang.Erfolgreich,
    this.options.errorMsg = this.options.Lang.Upps,
    this.options.showDelete = this.options.Lang.Bild_löschen 

    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }

    await this.getglobal();
  },
  methods: {
      
    async getglobal(){
      let self = this;
    await self.doPost({}, 'getglobalinfo', function (res) {
      if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0];
          document.getElementById("favicon").href=process.env.VUE_APP_CRM_URL+"/titleImgs/favicon."+result.favicon
          const parsedValue = parseInt(result.defaultCount, 10);
          // Überprüfe, ob parsedValue eine ganze Zahl ist
          self.options.GlobalSettings = result;
          if (!isNaN(parsedValue)) {
            self.options.defaultCount = parsedValue;
          } else {
            self.options.defaultCount = 10;
          }
          //alert(self.options.defaultCount)
        }
      });self.test = true;
    },
    updateSeeAlertStatus(){
      this.options.showAlertBox = false;
    },
    async getModules(){
      let self = this;
      await self.doPost({}, 'getmodules', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for(let i = 0; i < result.length; i++){
            result[i].status = result[i].status == 1 ? true : false;
            self.options.modules.push(result[i])
          }
          self.options.modules.forEach(mod =>{
            if(mod.name == "helloEdit"){
              if(mod.status == true){
                self.options.ModulHelloEdit = true;
              }else{
                self.options.ModulHelloEdit = false;
              }
            }
            if(mod.name == "suppliermail"){
              if(mod.status == true){
                self.options.ModulSuppliermail = true;
              }else{
                self.options.ModulSuppliermail = false;
              }
            }
            if(mod.name == "kommentare"){
              if(mod.status == true){
                self.options.ModulKommentare = true;
              }else{
                self.options.ModulKommentare = false;
              }
            }
            if(mod.name == "collections"){
              if(mod.status == true){
                self.options.ModulCollections = true;
              }else{
                self.options.ModulCollections = false;
              }
            }
            if(mod.name == "passolution"){
              self.options.ModulPassolution = mod.status;
            }
            if(mod.name == "invoice_checkout"){
              self.options.ModulInvoiceCheckout = mod.status;
            }

          })
          self.renderComp = true;
        }
      });
    },
   
    checkLoggedIn() {
      let self = this;
      self.doPost({
        userdata: self.options.user
      }, 'ping', function (res) {
      })
    }
  },
  async created() {
    let self = this;
    this.options.isUploading = false;
    this.options.currentRoute = this.$router.currentRoute.name;
    // Always default to German first (especially important for login/2FA before user is known)
    self.options.Lang = self.options.German;
    if (self.options.user && self.options.user.loggedIn && self.options.user.token) {
      await self.doPost({ data: self.options.user }, 'getLangUser', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else if (res.data.data && res.data.data.length > 0) {
          const langCode = res.data.data[0].lang;
          if (self.options[langCode]) {
            self.options.Lang = self.options[langCode];
          } else {
            console.warn(`Unknown language code '${langCode}', falling back to German`);
            self.options.Lang = self.options.German;
          }
          self.options.user.lang = langCode;
          self.options.successMsg = self.options.Lang.Erfolgreich;
        } else {
          console.warn('Empty language data from getLangUser, using fallback');
          self.options.Lang = self.options.German;
          self.options.user.lang = 'German';
          self.options.successMsg = self.options.Lang.Erfolgreich;
        }
      });
    } else {
      // 🛑 NOT LOGGED IN: just set German by default for SignIn or guests
      self.options.Lang = self.options.German;
      self.options.user.lang = 'German';
    }

    const loggedInCheck = setInterval(() => {
      //console.log('setIntervall');
      if (self.options.currentRoute !== 'SignIn' && self.options.currentRoute !== "passwordHelp" && self.options.currentRoute !== "reset-password" ) {
        //console.log('checkLoggedIn');
        self.checkLoggedIn();
      } else {
        //console.log('clearInterval');
        clearInterval(loggedInCheck);
      }
    }, 30000);

    self.$once("hook:beforeDestroy", () => {
      //console.log('hook:beforeDestroy');
      clearInterval(loggedInCheck);
    });
    await self.getModules();
    //await self.getDefaultCount();
  }
}
</script>

<style lang="scss">
@use "./assets/style/app";
@use "./assets/style/General/animations/spinner";

/* Global Confirm Overlay to blur and cover everything, including sidebar */
#globalConfirmOverlay{
  position: fixed;
  inset: 0;
  z-index: 100000000001; /* above loading spinner */
  background: rgba(0,0,0,0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Ensure md-select dropdown menus appear above the overlay */
.md-menu-content.md-select-menu{
  z-index: 100000000002 !important;
}
#globalConfirmModal{
  background: #fff;
  padding: 2rem;
  width: 40rem;
  max-width: 90vw;
  max-height: 85vh;
  overflow: auto;
  border-radius: 12px;
}
#globalConfirmModal .confirmTitle{
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 20px 0;
  color: #222;
  text-align: center;
}
#globalConfirmModal .confirmMessage{
  font-size: 15px;
  line-height: 1.5;
  color: #444;
  margin: 0 auto 20px;
  text-align: left;
  max-width: 90%;
  white-space: pre-line;
}
#globalConfirmModal .global-confirm-input-wrap .md-field input.md-input,
#globalConfirmModal .global-confirm-input-wrap .md-field.md-has-value input.md-input{
  color: #202224 !important;
  -webkit-text-fill-color: #202224 !important;
}
#globalConfirmModal.confirm-styled{
  padding: 0;
  width: 899px;
  max-width: 899px;
  border-radius: 13px;
}
/* Header - matches FormImportTrip .header-row */
.confirm-header-row{
  display: flex;
  position: relative;
  padding-top: 48px;
  padding-bottom: 53.5px;
}
.confirm-dialog-title{
  font-size: 30px;
  font-weight: 500;
  margin-left: 70px;
}
/* Content area - matches FormImportTrip .content-area */
.confirm-content-area{
  padding: 35px 70px 40px 70px;
  border-top: 1px solid #e9e9e9;
}
.confirm-message-text{
  font-size: 16px;
  margin: 0 0 30px 0;
}
.confirm-form-grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px 60px;
}
.confirm-form-grid .font-600{
  font-weight: 600 !important;
}
/* Actions - matches FormImportTrip .actions-row */
.confirm-actions-row{
  padding: 20px 70px 30px 70px;
  padding-bottom: 100px;
  padding-top: 41px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e9e9e9;
}
/* Secrets Modal Overlay — same pattern as globalConfirmOverlay */
#secretsModalOverlay {
  position: fixed;
  inset: 0;
  z-index: 100000000001;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
}
#secretsModalBox {
  background: #fff;
  padding: 2rem;
  width: 480px;
  max-width: 90vw;
  max-height: 85vh;
  overflow: auto;
  border-radius: 12px;
}
#secretsModalBox .confirmTitle {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #222;
}
.sm-field {
  margin-bottom: 16px;
}
.sm-label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}
.sm-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.sm-input:focus {
  border-color: #448aff;
}
.sm-eye-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
}
.sm-eye-btn .md-icon {
  font-size: 20px !important;
  color: #888;
}
.sm-nezasa-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 8px;
}
.sm-nezasa-row.sm-nezasa-active {
  border-color: #4caf50;
  background: #f1f8e9;
}
.sm-nezasa-info {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sm-nezasa-active-badge {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
}
#alertBox{
    position: absolute;
    min-height: 5rem;
    max-height: 25rem;
    overflow-y: scroll;
    width: 60%;
    top: 15rem;
    left: 25%;
    background-color: white !important;
    z-index: +111111111;
  }
</style>